import { Model } from "@vuex-orm/core";
import type { Fields } from "@vuex-orm/core";
import VideoExport from "./VideoExport";

export default class Download extends Model {
  public static entity = "downloads";

  static primaryKey = "url";

  public static fields(): Fields {
    return {
      url: this.string(""),
      progress: this.number(0), // 0 - 1
      path: this.string(null).nullable(),
      failed: this.boolean(false),
      videoExportId: this.number(-1),
      videoExport: this.belongsTo(VideoExport, "videoExportId"),
    };
  }

  public url!: string;

  public progress!: number;

  public path!: string | null;

  public failed!: boolean;

  public videoExportId!: number;

  public videoExport!: VideoExport | undefined;

  public static afterCreate(model: Download): void {
    // eslint-disable-next-line no-param-reassign
    // model.progress = 0;
    // kick off the download from Electron
    window.desktop?.ipcRenderer.send("downloadURL", { url: model.url });
  }

  public open(): void {
    if (this.path) window.desktop?.ipcRenderer.send("openFile", { path: this.path });
  }
}
